import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { DeleteOfflinePaymentDialogComponent } from 'app/components/app-layout/shared/delete-offline-payment-dialog/delete-offline-payment-dialog.component';
import { LegfiCurrencyPipeModule } from 'app/pipes/format/legfi-currency.module';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

@NgModule({
    declarations: [
        DeleteOfflinePaymentDialogComponent,
    ],
    imports: [
        SharedModule,
        MatDialogModule,
        MatInputModule,
        MatSelectModule,
        LegfiCurrencyPipeModule,
        MatSlideToggleModule,
    ],
    exports: [
        DeleteOfflinePaymentDialogComponent,
    ],
})
export class DeleteOfflinePaymentDialogModule
{
}
